import { useCallback, useEffect, useState } from 'react';

import { isMutationSuccessful } from 'modules/common/utils/isMutationSuccessful';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useDialog } from 'modules/common/hooks/useDialog';

import { useNegativeBalanceTermsOfServices } from './useNegativeBalanceTermsOfServices';

export enum DialogView {
  default = 'default',
  failed = 'failed',
}

export const useNegativeBalanceTermsOfServicesDialog = () => {
  const { group } = useAccount();

  const { isOpened, onClose, onOpen } = useDialog();

  const {
    acceptToS,
    isAccepting,
    isToSAccepted,
    isToSStatusLoading,
    isTosStatusLoaded,
  } = useNegativeBalanceTermsOfServices();

  const shouldShowDialog =
    !isToSAccepted && !isToSStatusLoading && isTosStatusLoaded;

  const [dialogView, setDialogView] = useState(DialogView.default);

  useEffect(() => {
    if (shouldShowDialog) {
      onOpen();
    } else {
      onClose();
    }
  }, [shouldShowDialog, onOpen, onClose]);

  const handleTryAgain = useCallback(async () => {
    const response = await acceptToS({ group });

    if (!isMutationSuccessful(response)) {
      setDialogView(DialogView.failed);
    } else {
      onClose();
    }
  }, [group, setDialogView, acceptToS, onClose]);

  const handleCloseFailedDialog = useCallback(() => {
    setDialogView(DialogView.default);
  }, []);

  return {
    dialogView,
    handleCloseFailedDialog,
    handleTryAgain,
    isAccepting,
    isOpened,
  };
};
